import React from "react";
import { styled } from "@linaria/react";
import { color, fonts, radius } from "..";

const CARD_INNER_PADDING_PX = 24;
const CARD_INNER_ROW_GAP_PX = 24;

export const EmptyCard = styled.div`
  display: flex;
  flex-direction: column;

  flex: 1;
  height: 100%;

  border: 1px solid;
  border-color: ${color.titanium200};
  border-radius: ${radius};

  background-color: ${color.hydrogen};
  color: ${color.carbon900};
`;

const Wrapper = styled(EmptyCard)<{ innerPadding: number; innerRowGap: number }>`
  padding: ${({ innerPadding }) => innerPadding}px;
  row-gap: ${({ innerRowGap }) => innerRowGap}px;
  font: ${fonts.body1};
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  column-gap: 16px;
  flex-wrap: wrap;
  row-gap: 8px;
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;

  font: ${fonts.h3};
  color: ${color.carbon900};
`;

const Subtitle = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;

  font: ${fonts.h4};
  color: ${color.carbon900};
`;

interface P {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  innerPadding?: number;
  innerRowGap?: number;
}

const Card = ({
  title,
  subtitle,
  children,
  className,
  innerPadding = CARD_INNER_PADDING_PX,
  innerRowGap = CARD_INNER_ROW_GAP_PX,
}: P) => (
  <Wrapper className={className} innerPadding={innerPadding} innerRowGap={innerRowGap}>
    {title || subtitle ? (
      <Header>
        {title ? <Title>{title}</Title> : null}
        {subtitle ? <Subtitle>{subtitle}</Subtitle> : null}
      </Header>
    ) : null}
    {children}
  </Wrapper>
);

export default React.memo(Card);
